import { logFactory } from '../../util'
import { useQuery } from 'react-query'
import { useProviderRecommendationService } from '../services/providerRecommendation'
import { useEventTracking } from '../useEventTracking'
import { EventType } from '../../constants'
import { CreateRecommendationRequestEventData, RecommendationCreateOneRequest } from '../../types'
import { useRef } from 'react'

const hookName = 'useProviderRecommendations'
const log = logFactory(hookName)

const useProviderRecommendations = (request: RecommendationCreateOneRequest, enabled = true) => {
  const { createRecommendation, isReady } = useProviderRecommendationService()
  const { track: trackEvent } = useEventTracking()
  const trackedRequestRef = useRef<string>()

  const doQuery = async () => {
    log(`⭐️ Creating a recommendation...`, request)

    const timeStart = Date.now()
    const response = await createRecommendation(request)
    const timeEnd = Date.now()
    const timeInMs = timeEnd - timeStart

    const eventData: CreateRecommendationRequestEventData = {
      requestParams: request,
      timeInMs,
    }

    log(`⭐️ Returned recommendation...`, response)

    const currentRequestString = JSON.stringify(request)
    if (trackedRequestRef.current !== currentRequestString) {
      trackEvent(EventType.PROVIDER_RECOMMENDATION_SERVICE_TIME_LOADING_RECOMMENDATIONS, { data: eventData })
      trackedRequestRef.current = currentRequestString
    }

    return response
  }

  const {
    data: recommendations,
    isError,
    isLoading,
  } = useQuery([hookName, request], doQuery, {
    enabled: isReady && enabled,
  })

  return {
    recommendations,
    isError,
    isLoading: !isReady || isLoading,
  }
}

export { useProviderRecommendations, hookName as useProviderRecommendationsHookName }
